// @flow

import * as React from 'react';
import { useState } from 'react';
import type { Node } from 'react';

import './style.scss';

type Props = {
  onChange: () => void,
};

type LabelType = 'good first issue' | 'first timers only';

export default function LabelOptions(props: Props): Node {
  const [curLabel, setCurLabel] = useState<LabelType>('good first issue');
  const { onChange } = props;

  return (
    <form className="LabelOptions">
      <label
        htmlFor="goodFirstIssue"
        className={`LabelOptions__label ${
          curLabel === 'good first issue' ? 'LabelOptions__label--checked' : ''
        } `}
      >
        Good first issue
        <input
          className="LabelOptions__input"
          id="goodFirstIssue"
          type="radio"
          name="goodFirstIssue"
          value="good first issue"
          onChange={({ target: { value } }): void => {
            setCurLabel(value);
            onChange(value);
          }}
          checked={curLabel === 'good first issue'}
        />
      </label>
      <label
        htmlFor="firstTimersOnly"
        className={`LabelOptions__label ${
          curLabel === 'first timers only' ? 'LabelOptions__label--checked' : ''
        } `}
      >
        First timers only
        <input
          className="LabelOptions__input"
          id="firstTimersOnly"
          name="firstTimersOnly"
          type="radio"
          value="first timers only"
          onChange={({ target: { value } }): void => {
            setCurLabel(value);
            onChange(value);
          }}
          checked={curLabel === 'first timers only'}
        />
      </label>
    </form>
  );
}
